import {
  Col,
  message,
  PageHeader,
  Row,
  Spin,
  Select,
  Checkbox,
  Space,
  Tabs,
  Divider,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { connect } from "react-redux";
// import balanceGeneralPdf from "../../../../Pdf/balanceGeneralPdf";
import {
  SelectItem,
  Form,
  FormItem,
  cuentaMask,
  TableItem,
  dineroDisabledMask,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import "moment/locale/es";
import { ResponsiveBar } from "@nivo/bar";
import reporteDeCuentasCliente from "../../../../Pdf/reporteDeCuentasCliente";
moment.locale("es");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

class ReporteCuentasCliente extends Component {
  state = {
    loading: false,
    pdf: null,
    objetoClientes: null,
    todasClientes: null,
    objetoUsuarios: null,
    todasUsuarios: null,
    objetoProyectos: null,
    todasProyectos: null,
    objetoUniadesDeNegocio: null,
    todasUniadesDeNegocio: null,
    dataReporte: null,
    todasVentas: [],
    dataGrafico: [],
    subtotal: 0,
    totalImpuestos: 0,
    total: 0,
    totalRetenciones: 0,
    totalACobrar: 0,
    totalAbonos: 0,
    totalSaldo: 0,
    desglosarProductos: false,
    unSoloCliente: false,
    clienteSeleccionado: null,
    empresa: null,
  };

  atras() {
    this.props.history.goBack();
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        "clientes/selectClientes",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasClientes: res.data });
          this.setState({
            objetoClientes: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUsuarios: res.data });
          this.setState({
            objetoUsuarios: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    value.apellidoMaterno}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "unidadesdenegocio/selectUnidadesDeNegocio",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasUniadesDeNegocio: res.data });
          this.setState({
            objetoUniadesDeNegocio: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {cuentaMask(
                    value.nivel1 +
                    value.nivel2 +
                    value.nivel3 +
                    value.nivel4 +
                    value.nivel5
                  ) +
                    " - " +
                    value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    this.consultarReporteCuentasCliente({
      clientes: 0,
      vendedores: 0,
      filtrarProyecto: 0,
      estadoFacturas: 5,
    });
  }

  async crearGrafico(
    totalNoVencido,
    totalVencido30,
    totalVencido60,
    totalVencido90,
    totalVencidoMas
  ) {
    await this.setState({
      dataGrafico: [
        {
          Vencimiento: "No Vencido",
          Cantidad: totalNoVencido,
        },
        {
          Vencimiento: "Vencido 30 dias o menos",
          Cantidad: totalVencido30,
        },
        {
          Vencimiento: "Vencido 31 - 60 dias",
          Cantidad: totalVencido60,
        },
        {
          Vencimiento: "Vencido 61 - 90 dias",
          Cantidad: totalVencido90,
        },
        {
          Vencimiento: "Vencido mas de 90 dias",
          Cantidad: totalVencidoMas,
        },
      ],
    });
  }

  consultarReporteCuentasCliente(values) {
    this.setState({ loading: true });
    if (Array.isArray(values.clientes) && values.clientes.length === 1) {
      const clienteEncontrado = this.state.todasClientes.find(
        (cliente) => cliente._id === values.clientes[0]
      );
      this.setState({
        unSoloCliente: true,
        clienteSeleccionado: clienteEncontrado,
      });
    } else {
      this.setState({ unSoloCliente: false, clienteSeleccionado: null });
    }
    axios
      .post(
        "reportesAdministrativos/reporteCuentasCliente",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.crearGrafico(
            res.data.totalNoVencido,
            res.data.totalVencido30,
            res.data.totalVencido60,
            res.data.totalVencido90,
            res.data.totalVencidoMas
          );
          this.setState({
            loading: false,
            dataReporte: res.data,
            todasVentas: res.data.ventas,
            subtotal: res.data.subtotal,
            totalImpuestos: res.data.totalImpuestos,
            total: res.data.total,
            totalRetenciones: res.data.totalRetenciones,
            totalACobrar: res.data.totalACobrar,
            totalAbonos: res.data.totalAbonos,
            totalSaldo: res.data.totalSaldo,
            desglosarProductos: res.data.desglosarProductos,
            empresa: res.data.empresa,
          });
        } else if (res.data.success === 1) {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        } else {
          message.error("Ha sucedido un error y no se cargo bien el reporte");
        }
        this.setState({ loading: false });
      });
  }

  descargarExcel() {
    let datosDescargarSF = []; // Saldo A Favor
    let datosDescargarCC = []; // Cuentas Por Cobrar
    const esReporteIndividual = this.state.unSoloCliente;
    const cliente = this.state.clienteSeleccionado;

    const nombreCliente = esReporteIndividual
      ? (cliente.persona 
          ? cliente.razonSocial
          : `${cliente.nombre || ""} ${cliente.apellidoPaterno || ""} ${cliente.apellidoMaterno || ""}`.trim()
        ) || "NOMBRE CLIENTE"
      : "";
    const nombreEmpresa = this.state.empresa.nombre || "NOMBRE EMPRESA";

    if (this.state.desglosarProductos) {
      for (const valueVenta of this.state.todasVentas) {
        if (valueVenta.folio === "") {
          const venta = this.state.todasVentas.find(
            (todasventas) =>
              todasventas.folio !== "" &&
              todasventas._id.toString() === valueVenta._id.toString()
          );
          if (!venta) continue;

          const dataRow = esReporteIndividual
            ? {
              Fecha: venta.fechaFactura,
              Serie: venta.facturaSerie || venta.remisionSerie || venta.pagoSerie || "",
              Folio: venta.facturaNumero || venta.remisionNumero || venta.pagoNumero || "",
              Moneda: valueVenta.moneda,
              "Tipo de Cambio": valueVenta.tipoDeCambio,
              "Fecha probable de pago": venta.fechaPago,
              "Total a Cobrar": venta.totalPagar,
              "Fecha Vencimiento": venta.fechaVencimiento,
              "Orden de Compra": venta.ordenDeCompra || "",
              Total: venta.total,
              Abonos: venta.anticipo
                ? venta.totalPagadoAnticipos
                : venta.totalPagado,
              Saldo: venta.saldo,
              Estado: venta.estado,
              Vendedor: venta.vendedor,
            }
            : {
              Fecha: venta.fechaFactura,
              Serie: venta.facturaSerie || venta.remisionSerie || venta.pagoSerie || "",
              Folio: venta.facturaNumero || venta.remisionNumero || venta.pagoNumero || "",
              Moneda: valueVenta.moneda,
              "Tipo de Cambio": valueVenta.tipoDeCambio,
              Cliente: venta.cliente,
              "Fecha probable de pago": venta.fechaPago,
              "Total a Cobrar": venta.totalPagar,
              "Fecha Vencimiento": venta.fechaVencimiento,
              "Orden de Compra": venta.ordenDeCompra || "",
              Total: venta.total,
              Abonos: venta.anticipo
                ? venta.totalPagadoAnticipos
                : venta.totalPagado,
              Saldo: venta.saldo,
              Estado: venta.estado,
              Vendedor: venta.vendedor,
            };

          if (valueVenta.saldoAFavor) {
            datosDescargarSF.push(dataRow);
          } else {
            datosDescargarCC.push(dataRow);
          }
        }
      }
    } else {
      for (const valueVenta of this.state.todasVentas) {
        if (valueVenta.folio !== "") {
          const dataRow = esReporteIndividual
            ? {
              Fecha: valueVenta.fechaFactura,
              Serie: valueVenta.facturaSerie || valueVenta.remisionSerie || valueVenta.pagoSerie || "",
              Folio: valueVenta.facturaNumero || valueVenta.remisionNumero || valueVenta.pagoNumero || "",
              Moneda: valueVenta.moneda,
              "Tipo de Cambio": valueVenta.tipoDeCambio,
              "Fecha probable de pago": valueVenta.fechaPago,
              "Total a Cobrar": valueVenta.totalPagar,
              "Fecha Vencimiento": valueVenta.fechaVencimiento,
              "Orden de Compra": valueVenta.ordenDeCompra || "",
              Total: valueVenta.total,
              Abonos: valueVenta.anticipo
                ? valueVenta.totalPagadoAnticipos
                : valueVenta.totalPagado,
              Saldo: valueVenta.saldo,
              Estado: valueVenta.estado,
              Vendedor: valueVenta.vendedor,
            }
            : {
              Fecha: valueVenta.fechaFactura,
              Serie: valueVenta.facturaSerie || valueVenta.remisionSerie || valueVenta.pagoSerie || "",
              Folio: valueVenta.facturaNumero || valueVenta.remisionNumero || valueVenta.pagoNumero || "",
              Moneda: valueVenta.moneda,
              "Tipo de Cambio": valueVenta.tipoDeCambio,
              Cliente: valueVenta.cliente,
              "Fecha probable de pago": valueVenta.fechaPago,
              "Total a Cobrar": valueVenta.totalPagar,
              "Fecha Vencimiento": valueVenta.fechaVencimiento,
              "Orden de Compra": valueVenta.ordenDeCompra || "",
              Total: valueVenta.total,
              Abonos: valueVenta.anticipo
                ? valueVenta.totalPagadoAnticipos
                : valueVenta.totalPagado,
              Saldo: valueVenta.saldo,
              Estado: valueVenta.estado,
              Vendedor: valueVenta.vendedor,
            };

          if (valueVenta.saldoAFavor) {
            datosDescargarSF.push(dataRow);
          } else {
            datosDescargarCC.push(dataRow);
          }
        }
      }
    }

    const workbook = this.generarHojaEstadoDeCuenta(
      datosDescargarSF,
      datosDescargarCC,
      esReporteIndividual,
      nombreCliente,
      nombreEmpresa
    );

    const fileName = `Estado_Cuenta_${nombreCliente || "General"}_${moment()
      .locale("es")
      .format("YYYY-MM-DD")}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  }

  /**
   * Esta función CONSTRUYE y ESTILIZA la hoja de Excel.
   * @param {Array} datosSF - Datos de Saldo a Favor
   * @param {Array} datosCC - Datos de Cuentas por Cobrar
   * @param {boolean} esReporteIndividual - Define el layout
   * @param {string} nombreCliente - Nombre del cliente (si es individual)
   * @param {string} nombreEmpresa - Nombre de la empresa
   * @returns {Object} - El Workbook (libro de Excel) completo
   */
  generarHojaEstadoDeCuenta(
    datosSF,
    datosCC,
    esReporteIndividual,
    nombreCliente,
    nombreEmpresa
  ) {
    const headersBase = [
      "Fecha",
      "Serie",
      "Folio",
      "Moneda",
      "Tipo de Cambio",
      // "Cliente" se añade dinámicamente
      "Fecha probable de pago",
      "Total a Cobrar",
      "Fecha Vencimiento",
      "Orden de Compra",
      "Total",
      "Abonos",
      "Saldo",
      "Estado",
      "Vendedor",
    ];

    const anchosBase = [
      { wch: 12 },
      { wch: 15 },
      { wch: 8 },
      { wch: 15 },
      // "Cliente" se añade dinámicamente
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 12 },
      { wch: 12 },
      { wch: 12 },
      { wch: 15 },
      { wch: 25 },
    ];

    let headers;
    let anchosColumnas;
    let maxColIndex;
    let mergeColIndex;

    if (esReporteIndividual) {
      headers = [...headersBase];
      anchosColumnas = [...anchosBase];
      maxColIndex = 13;
      mergeColIndex = 13;
    } else {
      headers = [
        ...headersBase.slice(0, 4),
        "Cliente",
        ...headersBase.slice(4),
      ];
      anchosColumnas = [
        ...anchosBase.slice(0, 4),
        { wch: 30 },
        ...anchosBase.slice(4),
      ];
      maxColIndex = 14;
      mergeColIndex = 14;
    }
    const estiloTitulo = {
      font: { bold: true, sz: 18, color: { rgb: "FF000033" } },
      alignment: { horizontal: "center", vertical: "center" },
    };
    const estiloSubtitulo = {
      font: { bold: true, sz: 14 },
      alignment: { horizontal: "center", vertical: "center" },
    };
    const estiloHeader = {
      font: { bold: true, color: { rgb: "FFFFFFFF" } },
      fill: { fgColor: { rgb: "FF4472C4" } },
      alignment: { vertical: "center" },
    };
    const estiloFechaGen = {
      font: { italic: true, sz: 9 },
      alignment: { horizontal: "right" },
    };

    let filaEmpresa = [nombreEmpresa];

    let dataParaHoja = [
      ["Estado de Cuenta Cliente"], // Fila 1
      filaEmpresa, // Fila 2
      esReporteIndividual ? [nombreCliente] : [], // Fila 3
      [`Fecha Generación: ${moment().locale("es").format("L LT")}`], // Fila 4
      [], // Fila 5 (Blanca)
      ["Saldo a Favor"], // Fila 6
      headers, // Fila 7 (Encabezados SF)
    ];

    // Creamos la hoja inicial con los títulos
    const worksheet = XLSX.utils.aoa_to_sheet(dataParaHoja);

    // Añadimos los DATOS de Saldo a Favor (comenzando en Fila 8 / Celda A8)
    XLSX.utils.sheet_add_json(worksheet, datosSF, {
      origin: "A8", // Fila 8
      skipHeader: true,
      // header: headers,
    });

    let filaInicioCC = 8 + datosSF.length + 1;

    const dataSeccionCC = [["Cuentas por Cobrar"], headers];

    XLSX.utils.sheet_add_aoa(worksheet, dataSeccionCC, {
      origin: `A${filaInicioCC}`,
    });

    XLSX.utils.sheet_add_json(worksheet, datosCC, {
      origin: `A${filaInicioCC + 2}`,
      skipHeader: true,
      //header: headers,
    });

    // Anchos de Columna
    worksheet["!cols"] = anchosColumnas;

    // Lista de todas las celdas a fusionar
    let merges = [
      // {s: {r: fila_inicio, c: col_inicio}, e: {r: fila_fin, c: col_fin}}

      // Título Principal (Fila 1) - fusionado hasta N
      { s: { r: 0, c: 0 }, e: { r: 0, c: mergeColIndex - 1 } },
      // Nombre Empresa (Fila 2) - fusionado hasta N
      { s: { r: 1, c: 0 }, e: { r: 1, c: mergeColIndex - 1 } },
      // Fecha Generación (Fila 4) - fusionado hasta N
      { s: { r: 3, c: 0 }, e: { r: 3, c: mergeColIndex - 1 } },
      // Título "Saldo a Favor" (Fila 6) - fusionado hasta N
      { s: { r: 5, c: 0 }, e: { r: 5, c: mergeColIndex - 1 } },
      // Título "Cuentas por Cobrar" (Fila dinámica) - fusionado hasta N
      {
        s: { r: filaInicioCC - 1, c: 0 },
        e: { r: filaInicioCC - 1, c: mergeColIndex - 1 },
      },
    ];

    // Fusión condicional para el Nombre del Cliente (Fila 3) - fusionado hasta N
    if (esReporteIndividual) {
      merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: mergeColIndex - 1 } });
    }

    worksheet["!merges"] = merges;

    try {
      // Títulos
      worksheet["A1"].s = estiloTitulo;
      worksheet["A2"].s = estiloSubtitulo;
      if (esReporteIndividual) {
        worksheet["A3"].s = estiloSubtitulo;
      }

      worksheet["A4"].s = estiloFechaGen;

      worksheet["A6"].s = estiloSubtitulo;
      worksheet[`A${filaInicioCC}`].s = estiloSubtitulo;

      for (let C = 0; C <= maxColIndex; ++C) {
        const cell_sf = XLSX.utils.encode_cell({ c: C, r: 6 });
        if (worksheet[cell_sf]) worksheet[cell_sf].s = estiloHeader;

        const cell_cc = XLSX.utils.encode_cell({ c: C, r: filaInicioCC });
        if (worksheet[cell_cc]) worksheet[cell_cc].s = estiloHeader;
      }
    } catch (error) {
      console.warn(
        "Error al aplicar estilos a celdas (puede ser normal si no hay datos):",
        error
      );
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Estado de Cuenta");

    return workbook;
  }

  descargarPdf() {

    const esReporteIndividual = this.state.unSoloCliente;

    const cliente = this.state.clienteSeleccionado;
    const nombreCliente = esReporteIndividual
      ? (cliente.persona
          ? cliente.razonSocial
          : `${cliente.nombre || ""} ${cliente.apellidoPaterno || ""} ${cliente.apellidoMaterno || ""}`.trim()
        ) || "NOMBRE CLIENTE"
      : "";

    pdfMake
      .createPdf(reporteDeCuentasCliente(this.state.dataReporte))
      .download(`Reporte_Cuentas_Cliente_${nombreCliente || "General"}_${moment().locale("es").format("L")}.pdf`);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }
  render() {
    const columns = [
      {
        title: "Folio",
        dataIndex: "folio",
        key: "folio",
        sorter: (a, b) => {
          if (a.folio < b.folio) {
            return -1;
          }
          if (a.folio > b.folio) {
            return 1;
          }
          return 0;
        },
        buscar: "folio",
        ellipsis: true,
      },
      {
        title: "Fecha",
        dataIndex: "fechaFactura",
        key: "fechaFactura",
        sorter: (a, b) => {
          if (
            moment(a.fechaFactura, "DD/MM/YYYY") <
            moment(b.fechaFactura, "DD/MM/YYYY")
          ) {
            return -1;
          }
          if (
            moment(a.fechaFactura, "DD/MM/YYYY") >
            moment(b.fechaFactura, "DD/MM/YYYY")
          ) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaFactura",
        ellipsis: true,
      },
      {
        title: "Cliente",
        dataIndex: "cliente",
        key: "cliente",
        sorter: (a, b) => {
          if (a.cliente < b.cliente) {
            return -1;
          }
          if (a.cliente > b.cliente) {
            return 1;
          }
          return 0;
        },
        buscar: "cliente",
        ellipsis: true,
      },
      {
        title: "Vencimiento",
        dataIndex: "fechaVencimiento",
        key: "fechaVencimiento",
        sorter: (a, b) => {
          if (!a.fechaVencimiento && !b.fechaVencimiento) return 0;
          if (!a.fechaVencimiento) return 1;
          if (!b.fechaVencimiento) return -1;
          if (
            moment(a.fechaVencimiento, "DD/MM/YYYY") <
            moment(b.fechaVencimiento, "DD/MM/YYYY")
          ) {
            return -1;
          }
          if (
            moment(a.fechaVencimiento, "DD/MM/YYYY") >
            moment(b.fechaVencimiento, "DD/MM/YYYY")
          ) {
            return 1;
          }
          return 0;
        },
        buscar: "fechaVencimiento",
        ellipsis: true,
      },
      {
        title: "Moneda",
        dataIndex: "moneda",
        key: "moneda",
        ellipsis: true,
      },
      {
        title: "T. C.",
        dataIndex: "tipoDeCambio",
        key: "tipoDeCambio",
        ellipsis: true,
      },
      {
        title: "Total",
        dataIndex: "totalPagar",
        key: "totalPagar",
        sorter: (a, b) => {
          if (a.totalPagar < b.totalPagar) {
            return -1;
          }
          if (a.totalPagar > b.totalPagar) {
            return 1;
          }
          return 0;
        },
        buscar: "totalPagar",
        render: (value) => dineroDisabledMask(value),
        align: "right",
        ellipsis: true,
      },
      {
        title: "Abonos",
        dataIndex: "totalPagado",
        key: "totalPagado",
        sorter: (a, b) => {
          if (a.totalPagado < b.totalPagado) {
            return -1;
          }
          if (a.totalPagado > b.totalPagado) {
            return 1;
          }
          return 0;
        },
        buscar: "totalPagado",
        ellipsis: true,
        render: (value, record) =>
          dineroDisabledMask(
            record.anticipo ? record.totalPagadoAnticipos : record.totalPagado
          ),
        align: "right",
      },
      {
        title: "Saldo",
        dataIndex: "saldo",
        key: "saldo",
        sorter: (a, b) => {
          if (a.saldo < b.saldo) {
            return -1;
          }
          if (a.saldo > b.saldo) {
            return 1;
          }
          return 0;
        },
        buscar: "saldo",
        ellipsis: true,
        render: (value) => dineroDisabledMask(value),
        align: "right",
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        sorter: (a, b) => {
          if (a.estado < b.estado) {
            return -1;
          }
          if (a.estado > b.estado) {
            return 1;
          }
          return 0;
        },
        buscar: "estado",
        ellipsis: true,
      },
      {
        title: "Vendedor",
        dataIndex: "vendedor",
        key: "vendedor",
        sorter: (a, b) => {
          if (a.vendedor < b.vendedor) {
            return -1;
          }
          if (a.vendedor > b.vendedor) {
            return 1;
          }
          return 0;
        },
        buscar: "vendedor",
        ellipsis: true,
      },
    ];
    return (
      <>
        <Form
          ref={this.formRef}
          name="reporteCuentasCliente"
          onFinish={this.consultarReporteCuentasCliente.bind(this)}
          onFinishFailed={this.onFinishFailed}
          initialValues={{
            periodo: [moment().subtract(1, "month"), moment()],
          }}
        >
          <PageHeader
            onBack={this.atras.bind(this)}
            title="Reporte Cuentas Cliente"
            style={{
              border: "1px solid rgb(235, 237, 240)",
              backgroundColor: "white",
              marginBottom: 10,
            }}
            extra={
              <div style={{ display: "flex", justifyContent: "right" }}>
                <Space>
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarExcel()}
                      icon={<FileExcelOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar Excel
                    </ButtonItem>
                  )}
                  {this.state.dataReporte && (
                    <ButtonItem
                      blanco
                      onClick={() => this.descargarPdf()}
                      icon={<FilePdfOutlined />}
                      style={{ display: "block", margin: "0 0 0 auto" }}
                    >
                      Descargar PDF
                    </ButtonItem>
                  )}
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Consultar
                  </ButtonItem>
                </Space>
              </div>
            }
          />
          <Spin spinning={this.state.loading}>
            <div
              style={{
                backgroundColor: "white",
                padding: 20,
                paddingTop: 5,
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Tabs
                style={{ margin: 0 }}
                tabBarExtraContent={{
                  left: (
                    <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>
                      Filtros:
                    </h1>
                  ),
                }}
              >
                <TabPane tabKey="2" key="2" forceRender tab="Clientes">
                  <FormItem name="clientes" noStyle margin>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Clientes"
                    >
                      {this.state.objetoClientes}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="3" key="3" forceRender tab="Vendedores">
                  <FormItem name="vendedores" margin noStyle>
                    <SelectItem
                      width="90%"
                      mode="multiple"
                      placeholder="Vendedores"
                    >
                      {this.state.objetoUsuarios}
                    </SelectItem>
                  </FormItem>
                </TabPane>
                <TabPane tabKey="4" key="4" forceRender tab="Proyecto">
                  <Row>
                    <Col span={8}>
                      <FormItem
                        name="filtrarProyecto"
                        required
                        noStyle
                        initialValue={0}
                      >
                        <SelectItem width="90%" placeholder="Filtrar Proyecto">
                          <Option default value={0}>
                            Niguno
                          </Option>
                          <Option value={1}>Proyectos</Option>
                          <Option value={2}>Unidades de negocio</Option>
                        </SelectItem>
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                          const filtrarProyecto =
                            getFieldValue("filtrarProyecto");
                          if (filtrarProyecto === 1) {
                            return (
                              <FormItem
                                required
                                name="proyectos"
                                margin
                                noStyle
                              >
                                <SelectItem
                                  width="90%"
                                  placeholder="Proyectos"
                                  mode="multiple"
                                >
                                  {this.state.objetoProyectos}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                          if (filtrarProyecto === 2) {
                            return (
                              <FormItem
                                required
                                margin
                                name="unidadDeNegocioId"
                                noStyle
                              >
                                <SelectItem
                                  width="90%"
                                  placeholder="Unidades de Negocio"
                                >
                                  {this.state.objetoUniadesDeNegocio}
                                </SelectItem>
                              </FormItem>
                            );
                          }
                        }}
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
                <TabPane tabKey="5" key="5" forceRender tab="Detalles">
                  <Row style={{ padding: 0, margin: 0 }} gutter={[16, 0]}>
                    <Col span={8}>
                      <FormItem
                        label="Desglosar Productos"
                        name="desglosarProductos"
                        valuePropName="checked"
                        margin
                      >
                        <Checkbox />
                      </FormItem>
                    </Col>
                    <Col span={16}>
                      {/* <FormItem
                          label="Detalle"
                          name="detalle"
                          valuePropName="checked"
                          margin
                        >
                          <Checkbox />
                        </FormItem> */}
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginTop: 10,
                marginBottom: 10,
                height: "400px",
                borderRadius: 5, // borde redondeado
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)", // sombra ligera opcional
              }}
            >
              <h1 style={{ fontSize: "20px" }}>Grafico</h1>

              <ResponsiveBar
                data={this.state.dataGrafico}
                keys={["Cantidad"]}
                indexBy="Vencimiento"

                valueFormat={(e) => dineroDisabledMask(Math.abs(e))}

                margin={{ bottom: 100, left: 100 }}
                padding={0.3}

                groupMode="grouped"
                valueScale={{ type: "linear" }}
                indexScale={{ type: "band", round: true }}

                // columnas redondeadas
                borderRadius={6}

                borderColor={{
                  from: "color",
                  modifiers: [["darker", 1.6]],
                }}

                axisBottom={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Vencimiento",
                  legendPosition: "middle",
                  legendOffset: 32,
                }}

                axisLeft={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  format: (e) => dineroDisabledMask(Math.abs(e)), // formato dinero
                }}

                axisTop={null}
                axisRight={null}

                labelSkipWidth={12}
                labelSkipHeight={12}

                labelTextColor={{
                  from: "color",
                  modifiers: [["darker", 1.6]],
                }}

                colors={["#3ae6e6", "#cccc33", "#ebff33", "#ff6633", "#ff3a33"]}
                colorBy="index"
              />
            </div>
            <div
              style={{
                backgroundColor: "white",
                padding: 15,
                marginBottom: 10,
                height: "150px",
                borderRadius: 5,
                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
              }}
            >
              <Row gutter={[8, 8]}>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Subtotal</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.subtotal)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>+</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Impuestos</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalImpuestos)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>=</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.total)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>-</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Retenciones</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalRetenciones)}
                  </h1>
                </Col>
                <Col span={1} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>=</h1>
                </Col>
                <Col span={4} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total a Cobrar</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalACobrar)}
                  </h1>
                </Col>
              </Row>
              <Divider style={{ margin: 3 }} />
              <Row gutter={[8, 8]}>
                <Col span={6} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Total a Cobrar</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalACobrar)}
                  </h1>
                </Col>
                <Col span={2} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>-</h1>
                </Col>
                <Col span={6} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Abonos</p>
                  <h1 style={{ fontSize: 15 }}>
                    {dineroDisabledMask(this.state.totalAbonos)}
                  </h1>
                </Col>
                <Col span={2} style={{ textAlign: "center" }}>
                  <h1 style={{ fontSize: 20 }}>=</h1>
                </Col>
                <Col span={8} style={{ textAlign: "center" }}>
                  <p style={{ margin: 0 }}>Saldo Pendiente</p>
                  <h1 style={{ fontSize: 15, color: "#d9534f" }}>
                    {dineroDisabledMask(
                      this.state.totalSaldo ??
                      this.state.totalACobrar - this.state.totalAbonos
                    )}
                  </h1>
                </Col>
              </Row>
            </div>
            <TableItem
              onRow={(record, rowIndex) => {
                return {
                  onDoubleClick: (event) => {
                    this.props.history.push("/panel/verVenta", {
                      id: record._id,
                    });
                  },
                };
              }}
              rowKey={(value) => value._id.toString() + Math.random()}
              columns={columns}
              dataSource={this.state.todasVentas}
              size="small"
              pagination={false}
            />
            {/* <div style={{ backgroundColor: "white", padding: 20, paddingTop: 5 }}>
            {this.state.pdf && (
              <iframe
                title={"documentos"}
                style={{ width: "100%", height: "100vh" }}
                id="printPdf"
                name="printPdf"
              />
            )}
          </div> */}
          </Spin>
        </Form>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ReporteCuentasCliente);
